import { createUseStyles } from 'react-jss'
import { THEME } from 'components/theme'

export const LayoutStyles = createUseStyles({
  container: {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box'
  },
  headerContainer: {
    height: '8%',
    borderBottom: `solid 1px ${THEME.brandGreyPrimary}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 8px',
    boxSizing: 'border-box'
  },
  body: {
    height: '92%',
    maxHeight: '92%',
    minHeight: '700px',
    padding: '16px 8px',
    boxSizing: 'border-box',
    overflow: 'scroll',
    width: '100%',

    '&::-webkit-scrollbar': {
      width: '12px',
      height: '12px'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '20px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: THEME.brandGreen,
      cursor: 'pointer'
    }
  }
})

export const HeaderRightContainerStyles = createUseStyles({
  container: { display: 'flex', justifyContent: 'center', alignItems: ' center', gap: '10px' }
})

export const HeaderLeftContainerStyles = createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: ' center',
    gap: '10px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  title: {
    fontWeight: 'bold',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
})
